import { cn } from "@rekati/utils";
import { BrandLogo } from "./brand-logo";

interface Mark {
  src: string | null | undefined;
  name: string;
}

/**
 * The platform's signature on every page: "Powered by" the technology
 * partner, then the platform (decision 60, 84). Both logos come from
 * `GET /v1/brand`; the app passes the light or dark copy for its surface, and
 * a missing image falls back to the name. Wraps instead of overflowing.
 * Without `platform` it is the partner alone, for a surface that already
 * shows the platform's logo (the console's rail); `small` fits a header.
 */
export function PoweredBy({
  label,
  poweredBy,
  platform,
  small = false,
  className,
}: {
  label: string;
  poweredBy: Mark;
  platform?: Mark;
  small?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex min-w-0 flex-wrap items-center gap-y-2 text-muted-foreground",
        small ? "gap-x-2" : "gap-x-3",
        className,
      )}
    >
      <span
        className={cn("font-mono tracking-[0.16em] uppercase", small ? "text-[0.6rem]" : "text-[0.66rem]")}
      >
        {label}
      </span>
      <BrandLogo
        src={poweredBy.src}
        name={poweredBy.name}
        className={small ? "h-4 max-w-[7rem]" : "h-5 max-w-[9rem]"}
        textClassName={cn("text-foreground", small ? "text-xs" : "text-sm")}
      />
      {platform ? (
        <>
          <span className="h-4 w-px bg-border" aria-hidden="true" />
          <BrandLogo
            src={platform.src}
            name={platform.name}
            // The platform mark carries more blank space in its file than the partner's; taller to match.
            className="h-7 max-w-[8rem]"
            textClassName="font-mono text-xs"
          />
        </>
      ) : null}
    </div>
  );
}
